import React, { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon, ChevronUpDownIcon } from '@heroicons/react/24/outline';

export interface EstadoSort {
  campo: string;
  desc: boolean;
}

/** Hook de ordenação: clicar no mesmo campo inverte; campo novo começa asc. */
export function useSort(inicial: EstadoSort | null = null) {
  const [sort, setSort] = useState<EstadoSort | null>(inicial);
  const onSort = (campo: string) =>
    setSort((s) => (s && s.campo === campo ? { campo, desc: !s.desc } : { campo, desc: false }));
  return { sort, onSort, setSort };
}

/** `<th>` clicável com indicador de ordenação. Pra tabelas HTML (não-AG-Grid). */
const SortHeader: React.FC<{
  campo: string;
  label: React.ReactNode;
  sort: EstadoSort | null;
  onSort: (campo: string) => void;
  alinhar?: 'left' | 'right' | 'center';
  className?: string;
}> = ({ campo, label, sort, onSort, alinhar = 'left', className = '' }) => {
  const ativo = sort?.campo === campo;
  const Icone = ativo ? (sort!.desc ? ChevronDownIcon : ChevronUpIcon) : ChevronUpDownIcon;
  const just = alinhar === 'right' ? 'justify-end' : alinhar === 'center' ? 'justify-center' : 'justify-start';
  const align = alinhar === 'right' ? 'text-right' : alinhar === 'center' ? 'text-center' : 'text-left';
  return (
    <th className={`px-3 py-2 font-medium ${align} ${className}`}>
      <button
        type="button"
        onClick={() => onSort(campo)}
        className={`inline-flex w-full items-center gap-1 ${just} transition-colors hover:text-zinc-900 dark:hover:text-zinc-100 ${
          ativo ? 'text-zinc-900 dark:text-zinc-100' : ''
        }`}
        title="Ordenar"
      >
        <span>{label}</span>
        <Icone className={`h-3 w-3 flex-shrink-0 ${ativo ? 'text-blue-600 dark:text-blue-400' : 'text-zinc-400'}`} />
      </button>
    </th>
  );
};

export default SortHeader;
